import {wysiwygComponentVariants} from '~/cms/components/WYSIWYG/_utils/variants'
import {getArticleListingProps} from '~/cms/helpers/getArticleListingProps'
import {HgArticlePromoRecirculation as HgArticleWYSIWYGPromoRecirculation} from '~/design-system/hg/components'
import {type ArticleWysiwygPromoRecirculationFragment} from './_generated/fragment.graphql'

type DatoWYSIWYGPromoRecirculationProps = ArticleWysiwygPromoRecirculationFragment

export const DatoWYSIWYGPromoRecirculation = ({
  recirculationTitle,
  articles,
}: DatoWYSIWYGPromoRecirculationProps) => {
  const {promo} = wysiwygComponentVariants()
  return (
    <HgArticleWYSIWYGPromoRecirculation
      title={recirculationTitle}
      articles={articles.map(articleListing => {
        return {
          ...getArticleListingProps(articleListing),
          subheading: '',
          authors: [{...articleListing.authors[0]}],
        }
      })}
      className={promo()}
    />
  )
}
